import { render, staticRenderFns } from "./InvoiceStatusBadge.vue?vue&type=template&id=47c0e4a6&scoped=true"
import script from "./InvoiceStatusBadge.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0e4a6",
  null
  
)

export default component.exports